import BaseRunningTextTheme from './theme'
const THEME_NAME = 'default'

class TrThemeDefault extends BaseRunningTextTheme {

  font() {
    return {
      var: '--defaultFontFamily', default: 'Poppins'
    }
  }
  styles() {
    return [
      {key: `rt_1_clr1`, var: '--defaultMarqueeBgColor', default: '#be1e2d'},
      {key: `rt_1_clr2`, var: '--defaultMarqueeTextColor', default: '#ffffff'},
      {key: `rt_1_clr3`, var: '--defaultHighlightColor', default: '#ffc849'},
    ];
  }
  stylesTextShadow() {
    return [
      {var: '--defaultMarqueeTextShadow', default: '0px 2px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000'}
    ];
  }
  html() {
    if(this.setting['rt_type'] == 'top-supporters') {
      return `<span class="no"></span>
    <strong class="highlight">
      <span>&nbsp;&nbsp;&nbsp;</span>
    </strong>
    <div class="unit-icon"></div>
    <div>
      <span class="sum"></span>
      <span class="unit-name"></span>
    </div>
    `;
    } else {
      return `
      <strong class="highlight"></strong>
      <span>mentraktir</span>
      <div class="unit-icon"></div>
      <span class="sum"></span>
      <span class="unit-name"></span>
      <i class="supporter-message" style="margin-right: 0px"></i>
      `;
    }
  }

}

h.setProp(window, `tr.rt.${THEME_NAME}`, new TrThemeDefault(THEME_NAME));
